module.exports = __webpack_public_path__ + "img/liaison_inputbox.09b26d6e.png";